export function reviewsVideo() {
  document.querySelectorAll('.video-wrapper').forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const playBtn = wrapper.querySelector('.play-btn');

    playBtn.addEventListener('click', () => {
      video.play();
      video.setAttribute('controls', 'controls');
      playBtn.classList.add('hidden');
      wrapper.classList.add('video-wrapper--active');
    });

    const resetState = () => {
      video.removeAttribute('controls');
      playBtn.classList.remove('hidden');
      wrapper.classList.remove('video-wrapper--active');
    };

    video.addEventListener('pause', resetState);
    video.addEventListener('ended', resetState);
  });
}
